import React, { useState, useEffect } from "react";
import BaseModal from "./BaseModal";
import { useMessages } from "../../providers/MessagesContext";

const FeedbackModal: React.FC = () => {
  const { feedbackModal, closeFeedbackModal, onFeedbackSubmit } = useMessages();
  const [feedback, setFeedback] = useState("");

  // Reset feedback when modal opens/closes
  useEffect(() => {
    if (feedbackModal.isOpen) {
      setFeedback("");
    }
  }, [feedbackModal.isOpen]);

  // Focus on textarea when modal opens
  useEffect(() => {
    if (feedbackModal.isOpen) {
      const textarea = document.getElementById("feedbackText");
      setTimeout(() => {
        textarea?.focus();
      }, 100);
    }
  }, [feedbackModal.isOpen]);

  const handleSubmit = () => {
    if (feedbackModal.currentQueryId) {
      onFeedbackSubmit(feedbackModal.currentQueryId, feedback.trim());
    }
    closeFeedbackModal();
  };

  return (
    <BaseModal
      isOpen={feedbackModal.isOpen}
      onClose={closeFeedbackModal}
      title="Flag Message"
      allowBackdropClose={true}
      showCloseButton={true}
      maxWidth="max-w-md"
      maxHeight="max-h-[85vh]"
      footerButtonText="Submit Feedback"
      onFooterButtonClick={handleSubmit}
    >
      <div className="space-y-4">
        <p className="text-gray-600 text-sm">
          What answer would have been most helpful here?
        </p>

        <textarea
          id="feedbackText"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Please describe what would have been more helpful..."
          className="w-full min-h-[120px] p-3 border border-gray-300 rounded-md resize-vertical text-sm focus:outline-none focus:border-[#46ACC6] focus:ring-1 focus:ring-[#46ACC6]"
          onKeyDown={(e) => {
            if (e.key === "Enter" && e.ctrlKey) {
              handleSubmit();
            }
          }}
        />
      </div>
    </BaseModal>
  );
};

export default FeedbackModal;
